type Props = {
  color?: string;
};

/** A price tag: the plans and what they cost. */
const PricingIcon = ({ color = "currentColor" }: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" width={16} height={16} viewBox="0 0 16 16">
    <path
      fill={color}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.59 1.5H13A1.5 1.5 0 0 1 14.5 3v4.41a1.5 1.5 0 0 1-.44 1.06l-5.6 5.6a1.5 1.5 0 0 1-2.12 0L1.93 9.66a1.5 1.5 0 0 1 0-2.12l5.6-5.6a1.5 1.5 0 0 1 1.06-.44ZM11 6.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
    />
  </svg>
);

export default PricingIcon;
